module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/background-5bdd4c5bcf2f3ca38499b25ad2124467.webp";